import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  aff_plan: {},
  planloading: false,
  allplan:[]
};

const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    // addFaq: (state, action) => {
    //   state.faqs.push(action.payload);
    // },

    // updateFaq: (state, action) => {
    //   const index = state.faqs.findIndex(
    //     (faq) => faq.id === action.payload.id
    //   );
    //   if (index !== -1) {
    //     state.faqs[index] = action.payload;
    //   }
    // },

    // deleteFaq: (state, action) => {
    //   state.faqs = state.faqs.filter(
    //     (faq) => faq.id !== action.payload
    //   );
    // },

    // setAff_plan: (state, action) => {
    //    state.aff_plan = action.payload ?? {};
    // },

     setAllplan: (state, action) => {
       state.allplan = action.payload ?? {};
    },
    setPlanloading: (state, action) => {
      state.planloading = action.payload;
    },

  },
});

export const {  setAllplan ,setPlanloading} = planSlice.actions;
export default planSlice.reducer;
